const getPageY = () => {
    const supportPageOffset = window.pageXOffset !== undefined;
    const isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');

    if (supportPageOffset) {
        return window.pageYOffset;
    }
    if (isCSS1Compat) {
        return document.documentElement.scrollTop;
    }

    return document.body.scrollTop;
};

export default getPageY;



/** WEBPACK FOOTER **
 ** ./src/utils/getPageY.js
 **/